import { Avatar as _Avatar, styled } from '@mui/material';

export const Avatar = styled(_Avatar)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
}));

export default Avatar;
